function stringifyPoint(wpt) {
  return `${wpt.lng.toFixed(5)},${wpt.lat.toFixed(5)}`;
}

export default stringifyPoint;
